import { useEffect, useState } from "react";
import { Checkbox } from "@shared/components/checkbox";
import { CHECKBOX_SIZE } from "@shared/components/checkbox/types";
import {
  ExploreFilterItem,
  ExploreFilterSchemaFields,
} from "@modules/new-explore/types";
import { useExplore } from "@modules/new-explore/hooks/useExplore";
import { toFarsiNumber } from "@utils/digits";
import { useRouter } from "next/router";
import useExplorePreloadedData from "@templates/new-explore/hooks/useExplorePreloadedData";

interface Props<T> {
  item: ExploreFilterItem<T>[];
  filterName: ExploreFilterSchemaFields;
}

// eslint-disable-next-line no-unused-vars
function CheckBoxFilter<T>({ filterName, item }: Props<string>) {
  const { removeFilterByValue, addFilter } = useExplore();
  const { activeFilters } = useExplorePreloadedData();

  const selectedActiveFilter = activeFilters
    ? activeFilters[filterName]?.filter_value || []
    : [];
  const { query } = useRouter();

  const [items, setItems] = useState(item);

  useEffect(() => {
    setItems(item);
  }, [item]);

  const handleOnChange = (
    filterValue: string,
    checked: boolean,
    name: string = ""
  ) => {
    let wasAllSelected = false;
    const isExist = query[filterName];

    setItems((prev) => {
      const newState = prev.map((item) =>
        item.name === filterValue ? { ...item, selected: checked } : item
      );

      return newState;
    });

    checked
      ? addFilter({
          filterName: filterName,
          value: filterValue,
          name,
          isSingle: wasAllSelected,
        })
      : isExist
        ? removeFilterByValue(filterName, filterValue)
        : addExtraFilter(filterValue);
  };

  const addExtraFilter = (filterValue: string) => {
    item
      .filter((filter) => filter.name !== filterValue)
      .map((item) => {
        if (item.selected) {
          addFilter({
            filterName: filterName,
            value: item?.name,
            name: item.persian_name,
          });
        }
      });
  };

  return (
    <>
      {items.map(({ name, persian_name, count }, index) => (
        <div className="w-max flex flex-wrap items-center py-2" key={index}>
          <Checkbox
            id={name}
            label={`${persian_name} ${
              count !== undefined ? `(${toFarsiNumber(count)})` : ""
            }`}
            handleOnChange={(id, checked) =>
              handleOnChange(id, checked, persian_name)
            }
            disabled={count === 0}
            selected={
              selectedActiveFilter.some((value) => value.id === name)
                ? "checked"
                : "unChecked"
            }
            size={CHECKBOX_SIZE.LARGE}
            className="text-fds-secondary"
          />
        </div>
      ))}
    </>
  );
}

export default CheckBoxFilter;
